import { render, staticRenderFns } from "./template_product_inputs.vue?vue&type=template&id=3a2c665d"
import script from "./template_product_inputs.vue?vue&type=script&lang=js"
export * from "./template_product_inputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports